import { render, staticRenderFns } from "./search-notes.vue?vue&type=template&id=3dc8d9e2"
import script from "./search-notes.vue?vue&type=script&lang=js"
export * from "./search-notes.vue?vue&type=script&lang=js"
import style0 from "./search-notes.vue?vue&type=style&index=0&id=3dc8d9e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports